import { Messages } from '../../../../codegen/Localize';
import { IRemoteRefreshScheduleInfo } from '../../../../ts/models/IRemoteRefreshScheduleInfo';
import { deleteRemoteExtractRefresh } from '../../../actions/spaces/DeleteRemoteExtractRefreshAction';
import { selectSpaceInfoItem } from '../../../selectors/ContentSelectors';
import { AppState } from '../../../state/AppState';
import { currentUserIsOwnerOrAdmin } from '../../../utils/MixedContentHelpers';
import { IEntityAction } from './IEntityAction';

export const DeleteRemoteExtractRefreshEntityAction:
  IEntityAction<IRemoteRefreshScheduleInfo, any> = {
  name: 'tasks-delete',
  translateName: Messages.delete_action,
  isVisible: () => true,
  isClickable: isClickable,
  createReduxAction: deleteRemoteExtractRefresh
};

function isClickable(
  availableActions: any,
  schedules: IRemoteRefreshScheduleInfo[],
  state: AppState
): boolean {
  const spaceItem = selectSpaceInfoItem(state);
  return currentUserIsOwnerOrAdmin(state, spaceItem);
}
